<template>
	<div class="activity-resource-card">
		<slot></slot>
	</div>
</template>

<style scoped>
.activity-resource-card {
	display: flex;
	align-items: center;
	gap: var(--spacing-md);
	min-width: 0;
	padding: var(--spacing-md);
	border: var(--border-width-thin) solid var(--neutral-200);
	border-radius: var(--border-radius-lg);
	background: var(--neutral-0);
}
</style>
